<mat-card class="slidecontent">
    
  <div class="pophead">
    
    <div class="head">
    <button mat-icon-button (click)="closeAiDetail(false)">
      <mat-icon>arrow_forward</mat-icon>
    </button>
    <h3>Bind Fields with AI</h3>

    <button mat-button color="primary" (click)="deleteSelectedFields()" *ngIf="ShowDeleteButton==true">
      <mat-icon>delete_outline</mat-icon> Delete
    </button>

    </div>

    

    <div class="">
      <button (click)="closeAiDetail(false)" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>




  </div>
  

  <div class="bindFields">

      <div class="coreSelectionHolder">
        <div class="block">
          <mat-radio-group aria-label="Select an option" color="primary">
            <mat-radio-button value="Core" >Core</mat-radio-button>
            <mat-radio-button value="Contact" >Contact </mat-radio-button>
            <mat-radio-button value="Company" >Company</mat-radio-button>
          </mat-radio-group>
        </div>


        <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput>
        </mat-form-field>

      </div>

    <div class="table" >
      <table cellspacing="0" cellpadding="0" >
        <tr>
          <!-- <th><input type="checkbox"></th> -->
          <th></th>
          <th width="22%" >Form Feilds</th>
          <th width="22%">System Feilds</th>
          <th width="6%"style="text-align: center;" >AI</th>
          <th width="50%">Value</th>
        </tr>
        <tr *ngFor="let item of ExtractDocument;let i = index">
          <td>
            <mat-checkbox color="primary" (change)="getCheckboxValues($event, item)">
            </mat-checkbox>
          </td>
          <td>{{item.key}}</td>
          <td>
            <mat-form-field class="width">
              <input matInput placeholder="Choose fields"
              (input)="searchFields($event.target.value,item)"
              [matAutocomplete]="auto"
              [formControl]="feildsCtrl"
              id="RoleCtrlID"/>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option (click)="fieldValueSelected(pro,item)" *ngFor="let pro of fieldListFiltered"
                  [value]="pro.fieldName">
                  <span>{{ pro.fieldName }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-form-field>
              <mat-label>Choose fields</mat-label>
              <mat-select  class="custom-select-style">               
                <mat-option *ngFor="let pro of Feildproperty" [value]="pro.fieldID">
                {{ pro.fieldName }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
          </td>
          <td style="text-align: center;" ><mat-icon>commit</mat-icon></td>
          <td>{{item.value}}</td>
        </tr>
        <!-- <tr>
          <td><input type="checkbox"></td>
          <td>Family Name</td>
          <td>Last Name</td>
          <td><mat-icon>commit</mat-icon></td>
          <td>Mcalpin</td>
        </tr> -->

      </table>
    </div>

  </div>
  <!-- *ngIf="ExtractDocument.length>0" -->
  <div class="bottomActions" >
    <button mat-stroked-button color="primary" [disabled]="" (click)="createFields()">Create Fields</button>
  
    <button mat-flat-button color="primary" [disabled]="" (click)="finishFields()">Finish</button>
  </div>
   

</mat-card>

  <app-loader></app-loader>